module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "pagev"
    }
  }), _c('h2', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/About_the_Author"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Acknowledgements"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")]), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Henry Rowntree and That Decision")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")]), _c('span', {
    staticClass: "space"
  }, [_vm._v(" The Tuke Business")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter03"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")]), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Joseph Rowntree (1801–1859): A Profound Influence")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")]), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Henry Isaac Rowntree (1838–1883): Early Days")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")]), _c('span', {
    staticClass: "space"
  }, [_vm._v(" York in the Mid-nineteenth Century")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")]), _c('span', {
    staticClass: "space"
  }, [_vm._v(" The Confectionery Industry in Mid-nineteenth Century England")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")]), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Chocolate and Quakers")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8")]), _c('span', {
    staticClass: "space"
  }, [_vm._v(" H. I. Rowntree & Co: ‘The Cocoa, Chocolate & Chicory Works’")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9")]), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Henry the Quaker: Life Outside Tanner’s Moat")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 10")]), _c('span', {
    staticClass: "space1"
  }, [_vm._v(" Enter Joseph Rowntree Junior")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 11")]), _c('span', {
    staticClass: "space1"
  }, [_vm._v(" Joseph Rowntree II (1836–1925): From Bootham School to Pavement to Tanner’s Moat")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 12")]), _c('span', {
    staticClass: "space1"
  }, [_vm._v(" The Haxby Road Years (1890–1925)")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 13")]), _c('span', {
    staticClass: "space1"
  }, [_vm._v(" The Cocoa and Chocolate Competition at the Start of the Twentieth Century")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 14")]), _c('span', {
    staticClass: "space1"
  }, [_vm._v(" Cocoa Works Magazine")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 15")]), _c('span', {
    staticClass: "space1"
  }, [_vm._v(" Out Of The Slums: New Earswick Garden Village")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch2"
  }, [_c('a', {
    attrs: {
      "id": "pagevi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 16")]), _c('span', {
    staticClass: "space1"
  }, [_vm._v(" Early Twentieth-Century Rowntree’s")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 17")]), _c('span', {
    staticClass: "space1"
  }, [_vm._v(" Rowntree’s at War, and After")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 18")]), _c('span', {
    staticClass: "space1"
  }, [_vm._v(" Benefits in the Workplace")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Epilogue: Epitaph")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix I: The Last Will and Testament of Henry Isaac Rowntree")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Appendix02",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix II: Rowntree’s Ongoing Heritage")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Appendix03",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix III: A Rowntree Family Tree")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix IV: A Rowntree Timeline")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix V: The Rowntrees and York Adult Schools")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Further_Reading",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Further Reading")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0